import styled from 'styled-components';

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 420px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ModalButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
